<template>
  <div>
    <defaultVue
      ref="defaultVue"
      :supplierId="supplierId"
      :submitType="submitType"
      @approval-status-change="onApprovalStatusChange"
    />
  </div>
</template>
<script>
import defaultVue from '../../companyInfoCenter/default.vue';

export default {
  components: {
    defaultVue,
  },
  props: ['supplierId', 'submitType'],
  methods: {
    refresh() {
      if (this.$refs.defaultVue) {
        this.$refs.defaultVue.InitData();
      }
    },
    onApprovalStatusChange(payload) {
      this.$emit('approval-status-change', payload);
    },
    /** 编辑模式：父页底部「保存」→ 先保存，成功后弹框询问是否提交（与产品一致） */
    todoSave() {
      const detail = this.$refs.defaultVue;
      if (!detail || typeof detail.saveCompanyInfo !== 'function') return;
      return detail.saveCompanyInfo();
    },
    saveApprovalRejectContent() {
      const detail = this.$refs.defaultVue;
      if (detail && typeof detail.saveApprovalRejectContent === 'function') {
        return detail.saveApprovalRejectContent();
      }
      return Promise.resolve(false);
    },
    finishCompanyApproval() {
      const detail = this.$refs.defaultVue;
      if (detail && typeof detail.finishCompanyApproval === 'function') {
        return detail.finishCompanyApproval();
      }
      return Promise.resolve(false);
    },
  },
};
</script>
